import { ErrorMessage, Field, useField } from 'formik';
import React from 'react';

export interface FormCheckboxProps {
  name: string;
  label: string;
  disabled?: boolean;
  className?: string;
  id?: string;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({
  name,
  label,
  disabled,
  className = '',
  id,
}) => {
  const [, meta] = useField({ name, type: 'checkbox' });
  const hasError = meta.touched && !!meta.error;
  const fieldId = id || `checkbox-${name}`;

  return (
    <div className={className}>
      <div className="flex items-center">
        <Field
          type="checkbox"
          name={name}
          id={fieldId}
          disabled={disabled}
          className={`
            h-4 w-4
            text-primary-500
            focus:ring-primary-200
            border-monday-border
            rounded
            cursor-pointer
            ${hasError ? 'border-red-500' : ''}
          `}
        />
        <label
          htmlFor={fieldId}
          className={`ml-2 form-label ${hasError ? 'text-error-500' : ''}`}
        >
          {label}
        </label>
      </div>

      {/* Error Message */}
      <ErrorMessage name={name} component="div" className="text-red-500 text-xs mt-1 ml-6" />
    </div>
  );
};

export default FormCheckbox;
